/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'trash': {
    width: 9,
    height: 12,
    viewBox: '0 0 9 12',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#FFF" d="M3.143 5.107a.393.393 0 10-.786 0v3.929a.393.393 0 00.786 0V5.107zm1.571 0a.393.393 0 10-.785 0v3.929a.393.393 0 00.785 0V5.107zm1.572 0a.393.393 0 00-.786 0v3.929a.393.393 0 00.786 0V5.107zM0 1.964c0 .217.176.393.393.393H8.25a.393.393 0 000-.786H6.286V.786A.786.786 0 005.5 0H3.143a.786.786 0 00-.786.786v.785H.393A.393.393 0 000 1.964zM5.5.786H3.143v.785H5.5V.786z"/><path pid="1" _stroke="#FFF" stroke-opacity=".8" d="M1.571 10.607a.393.393 0 01-.392-.393V3.536h6.285v6.678a.393.393 0 01-.393.393h-5.5z"/></g>'
  }
})
